/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Win_X64_Zip_TitleInputs */

const en_pc_dl_file_win_x64_zip_title = /** @type {(inputs: Pc_Dl_File_Win_X64_Zip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portable (64-bit)`)
};

const zh_pc_dl_file_win_x64_zip_title = /** @type {(inputs: Pc_Dl_File_Win_X64_Zip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`便携版（64 位）`)
};

/**
* | output |
* | --- |
* | "Portable (64-bit)" |
*
* @param {Pc_Dl_File_Win_X64_Zip_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_win_x64_zip_title = /** @type {((inputs?: Pc_Dl_File_Win_X64_Zip_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Win_X64_Zip_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_win_x64_zip_title(inputs)
	return zh_pc_dl_file_win_x64_zip_title(inputs)
});
export { pc_dl_file_win_x64_zip_title as "pc.dl.file.win_x64_zip.title" }